<template>
  <AppView title="重設密碼">
    <form action="#" @submit.prevent="submit" class="p-5">
      <v-field class="mb-5" :error="errors['tel']">
        <div class="flex space-x-4 flex-nowrap items-center">
          <p class="flex-none px-4">{{ inMo ? "(+853)" : "(+852)" }}</p>
          <input
            class="field flex-grow"
            type="tel"
            v-model="form['tel']"
            placeholder="聯絡電話"
            :disabled="submitting"
          />
        </div>
      </v-field>

      <div class="flex space-x-4 mb-4">
        <v-field :error="errors.code" class="flex-grow">
          <input
            type="text"
            class="field"
            v-model="form['tel_verify_code']"
            placeholder="短訊認證碼"
            :disabled="submitting"
          />
        </v-field>
        <div class="flex-none">
          <VerifyTelButton
            :disabled="submitting"
            :tel="form['tel']"
            type="forgot"
          />
        </div>
      </div>

      <v-field :error="errors['password']" class="mb-5">
        <input
          class="field"
          type="password"
          v-model="form['password']"
          placeholder="請輸入新密碼"
          :disabled="submitting"
        />
      </v-field>

      <v-field :error="errors['password_confirmation']" class="mb-5">
        <input
          class="field"
          type="password"
          v-model="form['password_confirmation']"
          placeholder="請再次輸入新密碼"
          :disabled="submitting"
        />
      </v-field>

      <button type="submit" class="btn w-full" :disabled="submitting">
        確定
      </button>
    </form>
    <div class="text-center">
      <p>
        <nuxt-link to="/auth/login" class="text-xs text-primary"
          >會員登入</nuxt-link
        >
      </p>
    </div>
  </AppView>
</template>

<script>
import VerifyTelButton from "@/components/forms/VerifyTelButton";
export default {
  components: {
    VerifyTelButton,
  },
  auth: false,
  data() {
    return {
      form: {},
      submitting: false,
    };
  },
  methods: {
    async submit() {
      if (this.submitting) return;
      try {
        this.submitting = true;
        this.$loader.load();
        await this.$axios.post("/api/forgot", this.form);
        this.$loader.success("密碼已重設");
        this.$router.push("/auth/login");
      } catch (e) {
        console.error(e);
        this.$loader.error();
        this.submitting = false;
      }
    },
  },
};
</script>
